module.exports = __webpack_public_path__ + "img/developer.74076bb1.png";